import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader, Play } from "lucide-react";

import { useAuth } from "@/auth/auth";
import { Button } from "@/components/ui/button";
import { toastInstanceCreationError } from "@/components/instance-creation-error";

type RunOnEmulatorButtonProps = {
	assetName: string;
	disabled?: boolean;
};

export function RunOnEmulatorButton({ assetName, disabled }: RunOnEmulatorButtonProps) {
	const auth = useAuth();
	const navigate = useNavigate();
	const [isStarting, setIsStarting] = useState(false);

	const handleRun = async () => {
		setIsStarting(true);
		try {
			const result = await auth.regionClient.androidInstances.create({
				wait: true,
				spec: {
					clues: [{ kind: "OSVersion", osVersion: "15" }],
					initialAssets: [{ kind: "App" as const, source: "AssetName" as const, assetName }],
				},
			});
			navigate(`/stream/${result.metadata.id}`);
		} catch (error: unknown) {
			toastInstanceCreationError(error);
			setIsStarting(false);
		}
	};

	return (
		<Button className="w-full" disabled={disabled || isStarting} onClick={() => void handleRun()}>
			{isStarting ? (
				<>
					<Loader className="mr-2 h-4 w-4 animate-spin" />
					Starting...
				</>
			) : (
				<>
					<Play className="mr-2 h-4 w-4" />
					Run on emulator
				</>
			)}
		</Button>
	);
}
